import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      driver,
    },
  }
})
